import * as React from 'react'; // https://github.com/aelbore/esbuild-jest/issues/61
import Serializer, {
  type DeserializeArguments,
  type SerializeArguments,
} from './Serializer';
import { type TableRowElement } from '../../types/aha-editor';
import { isTableRowElement } from '../../types/guards';
import { isHTMLElementNode } from '../helpers/serializerHelpers';

class SerializerTableRow extends Serializer {
  static serialize({ node, children }: SerializeArguments) {
    if (!isTableRowElement(node)) return;

    return <tr className="Editor__tr">{children}</tr>;
  }

  static deserialize({
    el,
    next,
  }: DeserializeArguments): TableRowElement | undefined {
    if (!isHTMLElementNode(el) || el.tagName.toLowerCase() !== 'tr') return;

    // Filter out numbered row cells when deserializing
    const childElements = Array.from(el.children).filter(
      (child) =>
        !(
          isHTMLElementNode(child) &&
          (child.classList.contains('Editor__th--row-number') ||
            child.classList.contains('Editor__th--row-number-header'))
        )
    );

    return {
      type: 'table-row',
      children: next(childElements, {}),
    };
  }
}

export default SerializerTableRow;
